/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/AuthorDetails/theme';

export const AuthorDetailsTheme = theme;
